// Botão "Responder" dos comentários (piki/features/Comments) — seta o
// campo oculto comment_parent do formulário Piki (#comment_comment_parent)
// e mostra um aviso "Respondendo a: {autor}" com opção de cancelar.
window.addEventListener( 'DOMContentLoaded', () => {

    const wrap = document.querySelector( '#comentarios' )
    if( !wrap ) return

    const parentField = wrap.querySelector( '#comment_comment_parent' )
    const form = wrap.querySelector( 'form.form-comment' )
    if( !parentField || !form ) return

    let notice = null

    const setReplying = ( id, author ) => {

        parentField.value = id || 0

        if( notice ){
            notice.remove()
            notice = null
        }

        if( id ){

            notice = document.createElement( 'div' )
            notice.className = 'replying-to'
            notice.innerHTML = 'Respondendo a <strong></strong> — <button type="button" class="cancel-reply">cancelar</button>'
            notice.querySelector( 'strong' ).textContent = author
            notice.querySelector( '.cancel-reply' ).addEventListener( 'click', () => setReplying( 0 ) )

            form.prepend( notice )
            form.scrollIntoView({ behavior: 'smooth', block: 'center' })

        }

    }

    wrap.addEventListener( 'click', ( event ) => {

        const button = event.target.closest( '.reply-comment-button' )
        if( !button ) return

        setReplying( button.dataset.commentId, button.dataset.author )

    })

})
